import React from 'react'
import { getCourseId } from '../../helpers/course'
import { NavLink } from 'react-router-dom'
import HeaderBackgroundImage from '../../static/img/default-bg.svg'
import { getConfiguration } from '../../helpers/configuration'

class EnrolmentsTabs extends React.Component {
  render() {
    return (
      <div
        className="header-bg subnav"
        style={{
          backgroundImage: `url(${HeaderBackgroundImage})`
        }}
      >
        <ul className="tab-container">
          {this.props.yearsEnrolled.map(year => {
            return (
              <li key={year}>
                <button className="span-button tab" onClick={() => this.props.setSelectedEnrolmentYear(year)}><span className="tab-txt">{year}</span></button>
                {/* <NavLink
                  className="tab"
                  to={`${getConfiguration('baseUrl')}/manage/units/${year}`}
                >
                  <span className="tab-txt">{year}</span>
                </NavLink> */}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default EnrolmentsTabs
